import * as React from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import AddChallenge from "../../components/Forms/AddChallenge";
import { UserAuth } from "../../context/AuthContext";

export default function AddChallengePage() {
  const { userData } = UserAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (userData && userData?.role !== "admin" && userData?.role !== "super") {
      navigate("/unauthorized", { replace: true });
    }
  }, [userData, navigate]);

  if (!userData || ( userData?.role !== "admin" && userData?.role !== "super") ) {
    return null;
  }

  return (
    <DashboardLayout title="Add Challenge">
      <AddChallenge />
    </DashboardLayout>
  );
}
